import React from 'react'
import PropTypes from 'prop-types'
import apiFetch from '../../../apiFetch.js'
import PasswordValidator from './PasswordValidator.js'
import ErrorList from './ErrorList.js'

export default class PasswordResetChangePasswordForm extends React.Component {
  static get propTypes () {
    return {
      email: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired,
      onCompletion: PropTypes.func.isRequired,
      isMobile: PropTypes.bool.isRequired,
    }
  }

  constructor (props) {
    super(props)

    this.passwordValidator = new PasswordValidator()

    this.state = {
      waitingForServer: false,
      error: null,
      password: '',
      passwordConfirm: '',
    }
  }

  render () {
    const classes = this.props.isMobile ? 'form ui' : null
    return (
      <form onSubmit={e => this.handleFormSubmit(e)} className={classes}>
        <p>
          Reset your password for <b>{this.props.email}</b>.
        </p>

        <ErrorList error={this.state.error} />

        <fieldset className='loginFields' disabled={this.state.waitingForServer}>
          <div className='loginRow loginLast'>
            <label htmlFor='PasswordReset-password'>Password:</label>
            <input
              id='PasswordReset-password'
              type='password'
              name='password'
              placeholder='new password'
              onChange={e => this.handleInputChange(e)}
              value={this.state.password}
              required
            />
            <label htmlFor='PasswordReset-passwordConfirm'>Password Confirmation:</label>
            <input
              id='PasswordReset-passwordConfirm'
              type='password'
              name='passwordConfirm'
              placeholder='confirm password'
              onChange={e => this.handleInputChange(e)}
              value={this.state.passwordConfirm}
              required
            />
          </div>

          <input
            className='loginSubmit'
            type='submit'
            value={this.state.waitingForServer ? 'Submitting…' : 'Change Password'}
          />
        </fieldset>
      </form>
    )
  }

  handleInputChange (e) {
    this.setState({ [e.target.name]: e.target.value })
  }

  handleFormSubmit (e) {
    e.preventDefault()

    let error = null
    const {password, passwordConfirm} = this.state

    if (!password) {
      error = new Error('The password field is required.')
    }
    else if (!passwordConfirm) {
      error = new Error('The password confirmation field is required.')
    }
    else {
      error = this.passwordValidator.validate(password)

      if (!error && password !== passwordConfirm) {
        error = new Error('The password and password confirmation must match exactly.')
      }
    }

    if (error) {
      this.setState({ error })
      return
    }

    this.setState({ error: null, waitingForServer: true })

    const {email, code} = this.props
    apiFetch('POST', 'Login/ChangePassword', { email, code, password })
      .then(() => {
        this.setState({ waitingForServer: false })
        this.props.onCompletion({ email, password })
      })
      .catch(error => this.setState({ error, waitingForServer: false }))
  }
}
